import { useState } from 'react';
import mm_logo from '../images/mm-logo.svg'
import './Wallet.css'
import { ethers } from 'ethers'
import WarningModal from './WarningModal.js';
import $ from 'jquery'




function Wallet() {

    const [walletStatus, setWalletStatus] = useState(false);
    const [accAddress, setAccountAddress] = useState("");


    async function requestAccount() {
        await window.ethereum.request({ method: 'eth_requestAccounts' });
    }

    // connect to wallet button
    async function connectWallet() {
        if (typeof window.ethereum !== 'undefined' && window.ethereum.isMetaMask) {
            await requestAccount()
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const currentNetwork = await provider.getNetwork()
            const accountAddress = await signer.getAddress()
            setAccountAddress(accountAddress.slice(0, 5) + "..." + accountAddress.slice(-5, -1))
            console.log(accountAddress)
            console.log(currentNetwork)
            setWalletStatus(true)
            $(function () {
                if(currentNetwork.chainId !== 4){
                $('.modal').css('display','block');
                }
            });
        }
        else {
            window.open("https://metamask.io/");
        }
    }
    
    function walletConnected() {
        return (
            <div className="col text-right">
                <a className="text-light mr-4 text-right" href="#"><i className="fab fa-twitter fa-lg align-middle" aria-hidden="true"></i></a>
                <a className='text-light mr-4' href='#'><i className="fab fa-discord fa-lg align-middle" aria-hidden="true"></i></a>
                <button type="button" className="btn btn-dark btn btn-outline-light btn-rounded" onClick={connectWallet}>
                    <div className="blob my-auto ml-1 mr-2"></div>
                    <span className="h6 mr-1 font-weight-bold">{accAddress}</span>
                </button>
            </div>
        )
    }

    function walletDisconnected() {
        return (
            <div className="col text-right">
                <a className="text-light mr-4 text-right" href="#"><i className="fab fa-twitter fa-lg align-middle" aria-hidden="true"></i></a>
                <a className='text-light mr-4' href='#'><i className="fab fa-discord fa-lg align-middle" aria-hidden="true"></i></a>
                <button type="button" className="btn btn-dark btn btn-outline-light btn-rounded" onClick={connectWallet}>
                    <img src={mm_logo} width="24px" className="mr-2 ml-1" />
                    <span className="h6 mr-1 font-weight-bold">Connect to Wallet</span>
                </button>
            </div>
        )
    }

    if (typeof window.ethereum !== 'undefined') {
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        provider.on("network", (newNetwork, oldNetwork) => {
            // When a Provider makes its initial connection, it emits a "network"
            // event with a null oldNetwork along with the newNetwork. So, if the
            // oldNetwork exists, it represents a changing network
            if (oldNetwork) {
                window.location.reload();
            }
        });
    }



    return (
        <div>
            <div className="py-4 pr-4">
                {walletStatus ? walletConnected() : walletDisconnected()}
            </div>
            <WarningModal />
        </div>
    );
}

export default Wallet;